/**
 * Created by zhangxf on 2017/7/6.
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
// 这里定义初始值
let state = {
  count:10,
  language:'en',
  langs:[{lang:true,ab:'en'},{lang:false,ab:'zh'},{lang:false,ab:'fr'},{lang:false,ab:'de'},{lang:false,ab:'sw'},
         {lang:false,ab:'en'},{lang:false,ab:'hk'},{lang:false,ab:'en'},{lang:false,ab:'it'},{lang:false,ab:'du'},
         {lang:false,ab:'en'},{lang:false,ab:'po'},{lang:false,ab:'es'},{lang:false,ab:'tr'},{lang:false,ab:'en'},
         {lang:false,ab:'en'},{lang:false,ab:'cz'}, {lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'pl'},
         {lang:false,ab:'dk'},{lang:false,ab:'fi'},{lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},
         {lang:false,ab:'en'}, {lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},
         {lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},
         {lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'},{lang:false,ab:'en'}, {lang:false,ab:'en'}, ],
  country:[true,false,false,false,false,false,false,false,false,false,
           false,false,false,false,false,false,false,false,false,false,
           false,false,false,false,false,false,false,false,false,false,
           false,false,false,false,false,false,false,false,false,false],
  users:[],
  header:false,
  patientName:'',

 //charts
  DataS:[],
  DataSG:[],
  DataBasal:[],
  DataBolus:[],

  DataD:[],
  olDataSG:[],

  //chartsSettings
  settingData:{},
  sessions:[],

  //Monitor
  sensor:{},
  pump:{},
  compileTimeout1:'',

  events: [],
  Request:[],

  alarm_display:'Off',
  unRead:0,
  patientPage:0,

};
//提交mutations的方式改变参数值
const mutations = {
  changLanguage(context,info){
    context.langs.map(function (e,i) {
      if(i ===info[1]){
        e.lang=true;
        context.language = e.ab;
        if(info[2]===1){
        localStorage.setItem('language',e.ab);
        }
        sessionStorage.setItem('language',e.ab);
      }else{
        e.lang=false;
      }
      return e;
    }) ;
    for(let i=0;i<context.country.length;i++){
      context.country[i] = (i===info[0])?true:false;
    }
    //保存国家编号
    if(info[2]===1){
      localStorage.setItem('index',info[0]);
      localStorage.setItem('languageIndex',info[1]);
    }
  },
  updatePatientPage(context,data){
    context.patientPage = data
  },
  updateUsers(context,data){
    context.users= data;
    sessionStorage.setItem('users',JSON.stringify(data));
  },

  updateDataS(context,data){
    context.DataS= data;
  },
  updateDataSG(context,data){
    context.DataSG= data;
  },
  updateOlDataSG(context,data){
    context.olDataSG= data;
  },
  updateBasal(context,data){
    context.DataBasal= data;
  },
  updateBolus(context,data){
    context.DataBolus= data;
  },
  updateDataD(context,data){
    context.DataD= data;
  },
  updatePatientName(context,data){
    context.patientName= data;
  },
  //未读消息
  updateUnRead(context,data){
    context.unRead = data;
  },
  //告警开关
  updateAlarm(context,data){
    context.alarm_display = data;
  },

  updateRequest(context,data){
    if(!data){
      context.Request =[];
    }else{
      context.Request.push(data);
    }
  },

  //Events
  updateEvents(context,data){
    context.events= data;
  },
  //Monitor
  updateSensor(context,data){
    context.sensor= data;
  },
  updatePump(context,data){
    context.pump= data;
  },

//chartSettings
  updateSettingData(context,data){
    context.settingData= data;
  },
  updateSessions(context,data){
    context.sessions= data;
    sessionStorage.setItem('sessions',JSON.stringify(data));
  },
};

// 事件触发后的逻辑操作
// 参数为事件函数  commit触发状态变更

const actions = {
  add(add){
    add.commit('add')
  },
  oddAdd({commit,state}){
    if (state.count % 2 === 0) {
      commit('add')
    }
  }
};

// 返回改变后的数值
const getters = {
  count(context){
    return context.count
  },
  getOdd(context) {
    return context.count % 2 === 0 ? '偶数' : '奇数'
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/auth/store.js